import { render, staticRenderFns } from "./fileDownloadList.vue?vue&type=template&id=85711678&scoped=true&"
import script from "./fileDownloadList.vue?vue&type=script&lang=js&"
export * from "./fileDownloadList.vue?vue&type=script&lang=js&"
import style0 from "./fileDownloadList.vue?vue&type=style&index=0&id=85711678&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85711678",
  null
  
)

export default component.exports